import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input } from "antd";
import { UpTriangleV2 } from "../../../../../../../../assets/RpmAssets/SvgIcons";
import {
  allergentOptions,
  l3navoptions,
  category,
  settingsoption,
} from "../../../../../../Constants/Menus/ConstantMenus";
import Dropdown from "../../../../../DropDown/Dropdown";
import { Link, useLocation, useRouteMatch, useHistory } from "react-router-dom";

import { vitalsettings,getvitalsettings } from "../../../../../../../../actions/RPMAction";
import SuccessModal from "../../../../../Modals/SuccessModel/SuccessModal";
import "./../../settingscomponent.css";
function BloodPressure() {
  const location = useLocation();
  let patientId = localStorage.getItem("patientId");
  let dispatch = useDispatch();
  let [activeTop, setActiveTop] = useState(0);
  let [activeTabname, setActiveTabName] = useState("Pulse");

  let [isSuccess, setSuccess] = useState(false);
  let [successMessage, setSuccessMessage] = useState("");
   
  const [form] = Form.useForm();

  let [BloodpressureData, setBloodpressureData] = useState({
    normalSystolicMin: "",
    normalSystolicmax: "",
    normalDiastolicMin:"",
    normalDiastolicmax:"",
    normalCategory: "",
    normalAction: "",

    abnormalSystolicMin: "",
    abnormalSystolicmax: "",
    abnormalDiastolicMin:"",
    abnormalDiastolicMax:"",
    abnormalCategory: "",
    abnormalAction: "",

    criticalSystolicmin: "",
    criticalSystolicMax: "",
    criticalDiastolicMin:"",
    criticalDiastolicmax:"",
    criticalCategory: "",
    criticalAction: "",
})


useEffect(() => {
  dispatch(getvitalsettings(patientId)); 
  },[BloodpressureData])

  let gettabname = ({ name }) => {
    setActiveTabName(name);
  };
  let reduxData = useSelector((state) => state);
  useEffect(() => {
    
    let pulseDataFromRedux = reduxData?.rpmreducer?.vitalsettings?.data?.blood_pressure ? reduxData.rpmreducer.vitalsettings.data.blood_pressure[0] : null
    
    console.log("pulseDataFromRedux",pulseDataFromRedux)
    if (pulseDataFromRedux) {
    let systolicData = splitsystolicdiastolic(pulseDataFromRedux.basevalue)[0]
    let diastolicData = splitsystolicdiastolic(pulseDataFromRedux.basevalue)[1]
    let systolicDataabnomal = splitsystolicdiastolic(pulseDataFromRedux.abnormalvalue)[0]
    let diastolicabnormalData = splitsystolicdiastolic(pulseDataFromRedux.abnormalvalue)[1]
    let systoliccriticalData = splitsystolicdiastolic(pulseDataFromRedux.criticallvalue)[0]
    let diastoliccriticalData = splitsystolicdiastolic(pulseDataFromRedux.criticallvalue)[1]

    console.log("******v*******")
      console.log("systolicData",systolicData)
      console.log("diastolicData",splitMinMax(diastolicData)[1])
      console.log("systolicDataabnomal",systolicDataabnomal)
      console.log("diastolicabnormalData",diastolicabnormalData)
      console.log("systoliccriticalData",systoliccriticalData)
      console.log("diastoliccriticalData",diastoliccriticalData)
      console.log("******v*******")
    setBloodpressureData({
     
      normalSystolicMin: splitMinMax(systolicData[0])[0],
      normalSystolicmax:splitMinMax(systolicData[0])[1],
      normalDiastolicMin:splitMinMax(diastolicData[1])[0],
      normalDiastolicmax:splitMinMax(diastolicData)[1],
      normalCategory: pulseDataFromRedux.category,
      normalAction: splitActions(pulseDataFromRedux.criticalaction)[0],

      abnormalSystolicMin: splitMinMax(systolicDataabnomal[0])[0],
      abnormalSystolicmax: splitMinMax(systolicDataabnomal[0])[1],
      abnormalDiastolicMin:splitMinMax(diastolicabnormalData[1])[0],
      abnormalDiastolicmax:splitMinMax(diastolicabnormalData[1])[1],
      abnormalCategory: pulseDataFromRedux.category,
      abnormalAction: splitActions(pulseDataFromRedux.criticalaction)[1],

      criticalSystolicmin: splitMinMax(systoliccriticalData[0])[0],
      criticalSystolicMax: splitMinMax(systoliccriticalData[0])[1],
      criticalDiastolicMin:splitMinMax(diastoliccriticalData[1])[0],
      criticalDiastolicmax:splitMinMax(diastoliccriticalData[1])[1],
      criticalCategory: pulseDataFromRedux.category,
      criticalAction: splitActions(pulseDataFromRedux.criticalaction)[2],
  })

  form.setFieldsValue({
    normalSystolicMin: splitMinMax(systolicData)[0],
    normalSystolicmax:splitMinMax(systolicData)[1],
    normalDiastolicMin:splitMinMax(diastolicData)[0],
    normalDiastolicmax:splitMinMax(diastolicData)[1],
    normalCategory: pulseDataFromRedux.category,
    normalAction: splitActions(pulseDataFromRedux.criticalaction)[0],

    abnormalSystolicMin: splitMinMax(systolicDataabnomal)[0],
    abnormalSystolicmax: splitMinMax(systolicDataabnomal)[1],
    abnormalDiastolicMin:splitMinMax(diastolicabnormalData)[0],
    abnormalDiastolicmax:splitMinMax(diastolicabnormalData)[1],
    abnormalCategory: pulseDataFromRedux.category,
    abnormalAction: splitActions(pulseDataFromRedux.criticalaction)[1],

    criticalSystolicmin: splitMinMax(systoliccriticalData)[0],
    criticalSystolicMax: splitMinMax(systoliccriticalData)[1],
    criticalDiastolicMin:splitMinMax(diastoliccriticalData)[0],
    criticalDiastolicmax:splitMinMax(diastoliccriticalData)[1],
    criticalCategory: pulseDataFromRedux.category,
    criticalAction: splitActions(pulseDataFromRedux.criticalaction)[2],
  });
}
  }, []);


  let splitMinMax = (value) => {
    console.log(value)
    if (value && value.split('-').length > 0) {
        return value.split('-')
    }
    else return ["", ""]

}

let splitActions = (value) => {

    if (value && value.split('|').length > 0) {
        return value.split('|')
    }
    else return ["", "", ""]
}

let splitsystolicdiastolic = (value) => {

  if (value && value.split('|').length > 0) {
      return value.split('|')
  }
  else return ["", "", ""]
}

/******************************************************************************** */
  let savesettings = (formData) => {

    console.log("formData",formData)
    let basevalues = formData.normalSystolicMin + "-" + formData.normalSystolicmax;
    let abnormalvalues = formData.abnormalSystolicMin + "-" + formData.abnormalSystolicmax;
    let criticalvalues = formData.criticalSystolicmin + "-" + formData.criticalSystolicMax;

    let basevaluesdia = formData.normalDiastolicMin + "-" + formData.normalDiastolicmax;
    let abnormalvaluesdia = formData.abnormalDiastolicMin + "-" + formData.abnormalDiastolicmax;
    let criticalvaluesdia = formData.criticalDiastolicMin + "-" + formData.criticalDiastolicmax;


    //let categories = formData.normalCategory.value + "|" + formData.abnormalCategory + "|" + formData.criticalCategory
    let categories =formData.normalCategory.value?formData.normalCategory.value:formData.normalCategory
    let normalactions =formData.normalAction.value?formData.normalAction.value:formData.normalAction;
    let abnormalactions =formData.abnormalAction.value?formData.abnormalAction.value:formData.abnormalAction;

    let criticalactions =formData.criticalAction.value?formData.criticalAction.value:formData.criticalAction;


    let action = normalactions + "|" +abnormalactions+ "|" + criticalactions


    let bvalue = basevalues + "|" + basevaluesdia;
    let abvalue = abnormalvalues + "|" + abnormalvaluesdia;
    let crvalue = criticalvalues + "|" + criticalvaluesdia;

    
    //let action =formData.normalAction.value + "|" + formData.abnormalAction.value + "|" + formData.criticalAction.value
    //dispatch(vitalsettings(patientId,bvalue,abvalue,crvalue,"blood_presure",basecategory));

    dispatch(
      vitalsettings(
        patientId,
        bvalue,
        abvalue,
        crvalue,
        "blood_pressure",
        categories,
        action
      )
    ).then((res) => {
      console.log("book_slot API result ==> ", res);
      if (res.info == "Data failed to update") {
        setSuccess(true);
        setSuccessMessage(res.info);
      } else {
        setSuccess(true);
        setSuccessMessage(res.info);
        dispatch(getvitalsettings(patientId)); 
      }
      // setPaymentLoading(false)
      console.log("book_slot API result ==> ", res);
    });
  };
  let onFinish = (formData) => {

    //Form submission when all fields are filled..................
    savesettings(formData)
  }
  let onFinishFailed = (e) => {
    console.log(e);
  }


  return (
    <div className="settings-item">

      <Form
       
        form={form}
        initialValues={{ ...BloodpressureData }}
        onFinishFailed={onFinishFailed}
        onFinish={onFinish}
      >

        <div className="settings-header"></div>

        <div className="table">
          <table>
            <tr>
              <td>
                <div className="table-row">
                  <div className="icon">
                    <UpTriangleV2 status="normal" />{" "}
                  </div>{" "}
                  Base/Normal
                </div>
              </td>
              <td>

                <Form.Item
                  name="normalSystolicMin"
                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                  initialValue={BloodpressureData.normalSystolicMin}
                >

                  <Input
                    
                    width={"60%"}
                    placeholder="Enter the systolic min"
                    /* onChange={(e) => {
                      setBasevalue(e.target.value);
                    }} */
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </td>
              <td>

                <Form.Item
                  name="normalSystolicmax"
                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                  initialValue={BloodpressureData.normalSystolicmax}
                >
                  <Input
                   
                    width={"60%"}
                    placeholder="Enter the systolic max"
                    // onChange={(e) => {
                    //   setMaxBasevalue(e.target.value);
                    // }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </td>
              <td>
                <Form.Item
                  name="normalDiastolicMin"
                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                  initialValue={BloodpressureData.normalDiastolicMin}
                  
                >
                  <Input
                    
                    width={"60%"}
                    placeholder="Enter the diastolic min"
                    // onChange={(e) => {
                    //   setDiastolicBasevalue(e.target.value);
                    // }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </td>
              <td>
                <Form.Item
                  name="normalDiastolicmax"
                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                  initialValue={BloodpressureData.normalDiastolicmax}
                >
                  <Input
                    
                    width={"60%"}
                    placeholder="Enter the diastolic max"
                    
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </td>
              <td>
                {/* <Input  width={"100%"} placeholder="Enter" onChange={(e) => {setBasevalueoto( e.target.value)}} /> */}

                <Form.Item
                  name="normalCategory"
                  rules={[{ required: true, message: 'Select categories!' }]}
                  //initialValue={BloodpressureData.normalCategory}
                >
                  <Dropdown
                    // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                    // onChange={updateTable}
                    data={category}
                    width={135}
                   // value={basecategory}
                    /* onChange={(e) => {
                      console.log(e);

                      setBasecategory(e.value);
                    }} */
                    placeholder="Categories"
                    title="Categories"
                    isV2
                  // value={element.Allergent}
                  />
                </Form.Item>
              </td>

              <td>

                <Form.Item
                  name="normalAction"
                  rules={[{ required: true, message: 'Select action!' }]}
                >
                  <Dropdown
                    /* value={baseaction}
                    onChange={(e) => {
                      console.log(e);

                      setActionbase(e.value);
                    }} */
                    data={allergentOptions}
                    width={135}
                    placeholder="Action"
                    isV2
                  // value={element.Allergent}
                  />
                </Form.Item>
              </td>
            </tr>
            <tr>
              <td>
                <div className="table-row">
                  <div className="icon">
                    <UpTriangleV2 status="abnormal" />{" "}
                  </div>{" "}
                  Abnormal
                </div>
              </td>
              <td>

                <Form.Item
                  name="abnormalSystolicMin"
                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                  initialValue={BloodpressureData.abnormalSystolicMin}
                >
                  <Input
                   
                    width={"100%"}
                    placeholder="Enter the systolic min"
                   /*  onChange={(e) => {
                      setAbnormalvalue(e.target.value);
                    }} */
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </td>
              <td>
                <Form.Item
                  name="abnormalSystolicmax"
                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                  initialValue={BloodpressureData.abnormalSystolicmax}
                >
                  <Input
                   
                    width={"100%"}
                    placeholder="Enter the systolic max"
                    // onChange={(e) => {
                    //   setMaxAbnormalvalue(e.target.value);
                    // }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </td>
              <td>
              <Form.Item
                  name="abnormalDiastolicMin"
                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                  initialValue={BloodpressureData.abnormalDiastolicMin}
                >
                <Input
                  
                  width={"100%"}
                  placeholder="Enter the diastolic min"
                  /* onChange={(e) => {
                    setDiastolicAbnormalvalue(e.target.value);
                  }} */
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                </Form.Item>
              </td>
              <td>
              <Form.Item
                  name="abnormalDiastolicmax"
                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                  initialValue={BloodpressureData.abnormalDiastolicmax}
                >
                <Input
                  //value={maxdiastolicabnormalvalue}
                  width={"100%"}
                  placeholder="Enter the diastolic max"
                  /* onChange={(e) => {
                    setMaxDiastolicAbnormalvalue(e.target.value);
                  }} */
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                </Form.Item>
              </td>
              <td>
                {/* <Input width={"100%"} placeholder="Enter" onChange={(e) => {setAbnormalvalueto( e.target.value)}}/> */}
                <Form.Item
                  name="abnormalCategory"
                  rules={[{ required: true, message: 'Select categories!' }]}
                >
                <Dropdown
                  // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                  // onChange={updateTable}
                  data={category}
                  //value={abnormalcategory}
                  width={135}
                  /* onChange={(e) => {
                    console.log(e);

                    setAbnormalcategory(e.value);
                  }} */
                  placeholder="Categories"
                  isV2
                // value={element.Allergent}
                />
                </Form.Item>
              </td>
              <td>
              <Form.Item
                  name="abnormalAction"
                  rules={[{ required: true, message: 'Select action!' }]}
                >
                <Dropdown
                  // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                 // value={abnormalaction}
                  data={allergentOptions}
                  width={135}
                  /* onChange={(e) => {
                    console.log(e);

                    setActionabnormal(e.value);
                  }} */
                  placeholder="Action"
                  isV2
                // value={element.Allergent}
                />
                </Form.Item>
              </td>
            </tr>
            <tr>
              <td>
                <div className="table-row">
                  <div className="icon">
                    <UpTriangleV2 status="critical" />{" "}
                  </div>{" "}
                  Critical
                </div>
              </td>
              <td>
              <Form.Item
                  name="criticalSystolicmin"
                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                  initialValue={BloodpressureData.criticalSystolicmin}
                >
                <Input
                 // value={criticalvalue}
                  width={"100%"}
                  placeholder="Enter the systolic min"
                  /* onChange={(e) => {
                    setCriticalvalue(e.target.value);
                  }} */
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                </Form.Item>
              </td>
              <td>
              <Form.Item
                  name="criticalSystolicMax"
                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                  initialValue={BloodpressureData.criticalSystolicMax}
                >
                <Input
                  //value={maxcriticalvalue}
                  width={"100%"}
                  placeholder="Enter the systolic max"
                  /* onChange={(e) => {
                    setMaxCriticalvalue(e.target.value);
                  }} */
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                </Form.Item>
              </td>
              <td>
              <Form.Item
                  name="criticalDiastolicMin"
                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                  initialValue={BloodpressureData.criticalDiastolicMin}
                >
                <Input
                 // value={diastoliccriticalvalue}
                  width={"100%"}
                  placeholder="Enter the diastolic min"
                  /* onChange={(e) => {
                    setDiastolicCriticalvalue(e.target.value);
                  }} */
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                </Form.Item>
              </td>
              <td>
              <Form.Item
                  name="criticalDiastolicmax"
                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                  initialValue={BloodpressureData.criticalDiastolicmax}
                >
                <Input
                  //value={maxdiastoliccriticalvalue}
                  width={"100%"}
                  placeholder="Enter the systolic max"
                 /*  onChange={(e) => {
                    setMaxDiastolicCriticalvalue(e.target.value);
                  }} */
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                </Form.Item>
              </td>
              <td>
                {/* <Input  width={"100%"} placeholder="Enter" onChange={(e) => {setCriticalvalueto( e.target.value)}}/> */}
                <Form.Item
                  name="criticalCategory"
                  rules={[{ required: true, message: 'Select categories!' }]}
                >
                <Dropdown
                  data={category}
                  width={135}
                 // value={criticalcategory}
                 /*  onChange={(e) => {
                    console.log(e);

                    setCriticalcategory(e.value);
                  }} */
                  placeholder="Categories"
                  isV2
                // value={element.Allergent}
                />
                </Form.Item>
              </td>

              <td>
              <Form.Item
                  name="criticalAction"
                  rules={[{ required: true, message: 'Select action!' }]}
                >
                <Dropdown
                  //value={criticalaction}

                  data={allergentOptions}
                  width={135}
                  /* onChange={(e) => {
                    console.log(e);

                    setActioncritical(e.value);
                  }} */
                  placeholder="Action"
                  isV2
                // value={element.Allergent}
                />
                </Form.Item>
              </td>
            </tr>
          </table>
        </div>
        <button type="submit" className="sbt-btn">
          SAVE
        </button>
        <SuccessModal
          state={isSuccess}
          setState={setSuccess}
          successMessage={successMessage}
        />
      </Form>
    </div>
  );
}

export default BloodPressure;
